import { API_BASE_URL } from '../../../config/api';
import { buildDigirasaRazorpayCallbackUrl } from '../../../api/webPublicApi';

/**
 * Parse Razorpay redirect / callback query parameters.
 * @param {string} search
 */
export function parseRazorpayReturnSearch(search) {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const orderNumber = String(params.get('orderNumber') || '').trim();
  const rzpPaymentId = String(params.get('razorpay_payment_id') || '').trim();
  const rzpOrderID = String(params.get('razorpay_order_id') || '').trim();
  const razorpaySignature = String(params.get('razorpay_signature') || '').trim();

  if (!orderNumber || !rzpPaymentId || !rzpOrderID || !razorpaySignature) {
    return null;
  }

  return { orderNumber, rzpPaymentId, rzpOrderID, razorpaySignature };
}

/**
 * Build Razorpay `callback_url` for redirect flows (netbanking, wallets, test card authorize).
 * Points at DigiRasa API, which redirects the browser to the SPA `/payment/return` page.
 * @param {string} orderNumber
 */
export function buildRazorpayCallbackUrl(orderNumber) {
  if (typeof window === 'undefined') return '';
  const pageOrigin = window.location.origin.replace(/\/+$/, '');
  // Localhost callback URLs are not whitelisted in Razorpay and can break checkout open.
  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(pageOrigin)) {
    return '';
  }
  return buildDigirasaRazorpayCallbackUrl(orderNumber);
}
